<template>
  <div id="app">
    <nav>
      <div class="title">
        <div>上虞服务业高质量发展指数</div>
      </div>
      <ul>
        <li @click="toIndex">首页 <i :class="queryPath == 'index' ? 'cust_bottom_icon' : ''"></i></li>
        <li @click="toData">指数数据 <i :class="queryPath == 'data' ? 'cust_bottom_icon' : ''"></i></li>
        <li @click="toComment">指数点评 <i :class="queryPath == 'comment' ? 'cust_bottom_icon' : ''"></i></li>
        <li @click="toTime">新闻资讯 <i :class="queryPath == 'time_info' ? 'cust_bottom_icon' : ''"></i></li>
        <li @click="toEnterprise">优质企业 <i :class="queryPath == 'enterprise' ? 'cust_bottom_icon' : ''"></i></li>
        <li @click="toWe">关于我们 <i :class="queryPath == 'aboutWe' ? 'cust_bottom_icon' : ''"></i></li>
        <li @click="toIntroduction">指数介绍 <i :class="queryPath == 'introduction' ? 'cust_bottom_icon' : ''"></i></li>
      </ul>
    </nav>
    <router-view></router-view>
    <Footer class="footer" :class="this.queryPath == 'comment' || this.queryPath == 'enterprise' ? 'footerTwo' : ''">
      <div>研发单位：杭州数亮科技股份有限公司</div>
      <div>备案号：<a href="">皖ICP备2022014318号</a></div>
    </Footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      queryPath: 'index'
    }
  },
  watch: {
    $route(v) {
      this.queryPath = v.name
    }
  },
  mounted() {

  },
  methods: {
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    },
    toData() {
      this.$router.push({
        path: '/data'
      })
    },
    toComment() {
      this.$router.push({
        path: '/comment'
      })
    },
    toTime() {
      this.$router.push({
        path: '/time_info'
      })
    },
    toEnterprise() {
      this.$router.push({
        path: '/enterprise'
      })
    },
    toWe() {
      this.$router.push({
        path: '/aboutWe'
      })
    },

    toIntroduction() {
      this.$router.push({
        path: '/introduction'
      })
    },

  },
}
</script>
<style lang="less" >
* {
  margin: 0px;
  padding: 0px;
  list-style: none;

  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }
}

@font-face {
  font-family: YouSheBiaoTiHei;
  src: url(./assets/fonts/YouSheBiaoTiHei-2.ttf);
}

@font-face {
  font-family: PingFangSC-Semibold, PingFang SC;
  src: url(./assets/fonts/PingFangSC.ttf);
}

@font-face {
  font-family: zihun59hao;
  src: url(./assets/fonts/字魂59号-创粗黑.TTF);
}

#app {

  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 1920px;
  margin: auto;

  nav {
    font-size: 20px;
    font-family: zihun59hao-chuangcuhei, zihun59hao;
    font-weight: normal;
    color: #254B7B;
    line-height: 24px;
    letter-spacing: 1px;
    position: absolute;
    display: flex;
    z-index: 2;
    margin-top: 20px;

    .title {
      text-align: center;
      width: 750px;
    }

    ul {
      width: 1152px;

      li {
        margin-left: 25px;
        float: left;

        .cust_bottom_icon {
          margin: auto;
          margin-top: 5px;
          display: block;
          width: 36px;
          height: 4px;
          background: #F7AE40;
          border-radius: 2px;
        }
      }
    }
  }

  .footer {
    width: 1920px;
    height: 130px;
    background: #F3F4F5;
    text-align: center;
    padding-top: 50px;
    a{
      color: #2c3e50;
      text-decoration: none;
    }
  }

  .footerTwo {
    background-color: #fff;
  }
}
</style>
